// Query params that carry a bearer credential and must never reach
// Sentry (breadcrumbs / request urls / transaction names). `wlt` is the
// waitlist magic-link token; `token` covers any other one-time link.
const SENSITIVE_QUERY_PARAMS = ['wlt', 'token'] as const

// Matches only the targeted param values — other url parts are untouched.
// Works for relative urls (unlike `new URL()` which throws on them).
const sensitiveParamPattern = new RegExp(
  `([?&](?:${SENSITIVE_QUERY_PARAMS.join('|')})=)[^&#]*`,
  'gi',
)

/**
 * Redact the values of sensitive query params (`wlt`, `token`) in a url,
 * leaving everything else untouched. Returns the input unchanged when it
 * is empty or carries none of the params. Safe for relative urls — never
 * throws the way `new URL(relativePath)` would.
 */
export const redactSensitiveQueryParams = (url?: string | null): string =>
  url ? url.replace(sensitiveParamPattern, '$1REDACTED') : (url ?? '')
